import React, { useState, useEffect } from 'react'
import {
  Input,
  Row,
  Col,
  Button,
  Typography,
  Table,
  Modal,
  Form,
  Select,
  Space,
  Checkbox,
} from 'antd'
import axios from 'axios'
import {
  DistrictMaster,
  StateMaster,
  TalukaMaster,
} from '../../AllAPI/StudentAPI'
import {
  PlusOutlined,
  EyeOutlined,
  SearchOutlined,
  EditOutlined,
  DownloadOutlined,
} from '@ant-design/icons'
import {
  BaseIp,
  GenerateCertificate,
  GetCasteCertificateData,
  IMG_BASE_URL2,
  UpdateCertificate,
} from '../../AllAPI/AdminAPI'
import { toast } from 'react-toastify'

const { Title } = Typography
const { TextArea } = Input
const { Option } = Select

const CreateCertificate = () => {
  const [data, setData] = useState([])
  const [searchText, setSearchText] = useState('')

  // --- FORM STATES USING useState ---
  const [feeName, setFeeName] = useState('')

  const [isModalOpen, setIsModalOpen] = useState(false)
  const [editingId, setEditingId] = useState(null)

  const BoardingYear = sessionStorage.getItem('BoardingYear')
  // const BranchId = sessionStorage.getItem('selected_branch')

  const [states, setStates] = useState([])
  const [districts, setDistricts] = useState([])
  const [talukas, setTalukas] = useState([])
  const [loadingDistricts, setLoadingDistricts] = useState(false)
  const [loadingTalukas, setLoadingTalukas] = useState(false)
  const [loading, setLoading] = useState(false)

  const [firstName, setFirstName] = useState('')
  const [middleName, setMiddleName] = useState('')
  const [lastName, setLastName] = useState('')
  const [address, setAddress] = useState('')
  const [stateId, setStateId] = useState(null)
  const [districtId, setDistrictId] = useState(null)
  const [talukaId, setTalukaId] = useState(null)

  const [whatsappNo, setWhatsappNo] = useState('')
  const [mobileError, setMobileError] = useState('')
  const [pincode, setPincode] = useState('')
  const [cityVillage, setCityVillage] = useState('')
  const [remark, setRemark] = useState('')
  const [documents, setDocuments] = useState([])

  // ✅ Fetch all states when page loads
  useEffect(() => {
    axios.get(StateMaster).then((res) => {
      setStates(res.data)

      // ✅ Default State = Karnataka
      // const defaultState = res.data.find((s) => s.stateenname === 'Karnataka')

      // if (defaultState) {
      //   setStateId(defaultState.id)
      //   handleStateChange(defaultState.id)
      // }

    })
  }, [])

  //  Fetch districts when state changes
  const handleStateChange = (newStateId) => {
    setStateId(newStateId)

    setDistrictId(null)
    setTalukaId(null)
    setDistricts([])
    setTalukas([])

    setLoadingDistricts(true)

    axios
      .get(`${DistrictMaster}/${newStateId}`)
      .then((res) => {
        setDistricts(res.data)

        const defaultDistrict = res.data.find(
          (d) => d.districtenname === 'Belagavi',
        )

        if (defaultDistrict) {
          setDistrictId(defaultDistrict.id)

          // PASS stateId explicitly
          handleDistrictChange(defaultDistrict.id, newStateId)
        }
      })
      .finally(() => setLoadingDistricts(false))
  }

  //  Fetch talukas when district changes
  const handleDistrictChange = (districtId, passedStateId) => {
    setDistrictId(districtId)
    setTalukaId(null)
    setTalukas([])
    setLoadingTalukas(true)

    axios
      //  use passedStateId, NOT stateId
      .get(`${TalukaMaster}/${passedStateId}/${districtId}`)
      .then((res) => {
        setTalukas(res.data)

        const defaultTaluka = res.data.find(
          (t) => t.talukaenname === 'Belagavi',
        )

        if (defaultTaluka) {
          setTalukaId(defaultTaluka.id)
        }
      })
      .finally(() => setLoadingTalukas(false))
  }

  const hasAadhar = documents.includes('Aadhaar Card') ? 1 : 0
  const hasSchoolLC = documents.includes('School LC') ? 1 : 0
  const hasOrders = documents.includes('Orders') ? 1 : 0

  // --- SAVE  function ----------
  const handleSubmit = async () => {
    setLoading(true)
    const saveObj = {
      applicantName: firstName,
      fatherName: middleName,
      surName: lastName,
      address: address,
      whatsapp_number: whatsappNo,
      pin_code: pincode,
      city: cityVillage,
      state: stateId,
      district: districtId,
      taluka: talukaId,
      year: BoardingYear ? Number(BoardingYear) : '',
      // document statuses
      aadhar_card_check: hasAadhar,
      school_lc_check: hasSchoolLC,
      orders_check: hasOrders,
      remark: remark,
    }

    try {
      const res = await axios.post(GenerateCertificate, saveObj)

      if (res.data == "REQUIRED") {
        toast.warn("All fields required!")
      }
      if (res.data.message === 'PDFGENERATED') {
        toast.success('PDF generated successfully!')
        handleCancel()
        fetchCertificateData()

        // 🔥 Make full URL of PDF
        const pdfFullPath = `${BaseIp}${res.data.pdfPath}`

        // 🔥 Open in a new tab
        window.open(pdfFullPath, '_blank')
      }
    } catch (err) {
      console.error(err)
      alert('Error submitting certificate')
    } finally {
      setLoading(false) // 👉 Stop loader
    }
  }
  // -----Update Function=========
  const handleEdit = async (data) => {
    setEditingId(data.id) // 👈 certificate id

    setFirstName(data.applicantName)
    setMiddleName(data.fatherName)
    setLastName(data.surName)
    setAddress(data.address)
    setWhatsappNo(data.whatsapp_number)
    setCityVillage(data.city)
    setPincode(data.pin_code)
    setRemark(data.remark)

    // documents
    const docs = []
    if (data.aadhar_card_check === 1) docs.push('Aadhaar Card')
    if (data.school_lc_check === 1) docs.push('School LC')
    if (data.orders_check === 1) docs.push('Orders')
    setDocuments(docs)

    // ✅ 1. Set State
    setStateId(data.state)

    // ✅ 2. Load districts for state
    setLoadingDistricts(true)
    const districtRes = await axios.get(`${DistrictMaster}/${data.state}`)
    setDistricts(districtRes.data)
    setLoadingDistricts(false)

    // ✅ 3. Set district
    setDistrictId(data.district)

    // ✅ 4. Load talukas for district
    setLoadingTalukas(true)
    const talukaRes = await axios.get(
      `${TalukaMaster}/${data.state}/${data.district}`,
    )
    setTalukas(talukaRes.data)
    setLoadingTalukas(false)

    // ✅ 5. Set taluka
    setTalukaId(data.taluka)

    setIsModalOpen(true)
  }

  const handleUpdate = async () => {
    const updateObj = {
      applicantName: firstName,
      fatherName: middleName,
      surName: lastName,
      address,
      whatsapp_number: whatsappNo,
      pin_code: pincode,
      city: cityVillage,
      state: stateId,
      district: districtId,
      taluka: talukaId,
      aadhar_card_check: documents.includes('Aadhaar Card') ? 1 : 0,
      school_lc_check: documents.includes('School LC') ? 1 : 0,
      orders_check: documents.includes('Orders') ? 1 : 0,
      remark,
    }

    try {
      setLoading(true)

      const res = await axios.put(
        `${UpdateCertificate}/${editingId}`,
        updateObj,
      )
      if (res.data.message === 'CERTIFICATEUPDATED') {
        toast.success('Certificate updated successfully')
        handleCancel()
        fetchCertificateData()
      }

      if (res.data.message === 'RECORDNOTFOUND') {
        toast.error('Record not found')
      }
    } catch (err) {
      toast.error('Update failed')
    } finally {
      setLoading(false)
    }
  }

  const handleCancel = () => {
    setIsModalOpen(false)
    setEditingId(null)

    setFirstName('')
    setMiddleName('')
    setLastName('')
    setAddress('')
    setWhatsappNo('')
    setPincode('')
    setCityVillage('')
    setRemark('')
    setDocuments([])

    setStateId(null)
    setDistrictId(null)
    setTalukaId(null)
    setDistricts([])
    setTalukas([])
  }

  useEffect(() => {
    fetchCertificateData()
  }, [])

  const fetchCertificateData = async () => {
    setLoading(true)
    try {
      const res = await axios.get(
        `${GetCasteCertificateData}/${BoardingYear}`,
      )

      if (res.data === 'NOTFOUND') {
        toast.warn('Data not found!')
      }

      const formatted = res.data.map((item, index) => ({
        key: item.id,
        index: index + 1,
        certificate_number: item.certificate_number,
        applicantName: item.applicantName,
        fatherName: item.fatherName,
        surName: item.surName,
        year: item.year,
        whatsapp_number: item.whatsapp_number,
        city: item.city,
        pin_code: item.pin_code,
        full_data: item,
      }))

      setData(formatted)
    } catch (err) {
      toast.error('Failed to load fees')
    } finally {
      setLoading(false) // 👉 Stop loader
    }
  }

  const setViewGeneratedPdf = (record) => {
    // 🔥 Make full URL of PDF
    const pdfFullPath = `${IMG_BASE_URL2}${record.filename}`
    // 🔥 Open in a new tab
    window.open(pdfFullPath, '_blank')
  }

  const downloadPdf = async (record) => {
    try {
      const pdfUrl = `${IMG_BASE_URL2}${record.filename}`

      const response = await axios.get(pdfUrl, {
        responseType: 'blob',
      })

      const blob = new Blob([response.data], {
        type: 'application/pdf',
      })

      const url = window.URL.createObjectURL(blob)

      const link = document.createElement('a')
      link.href = url

      // ✅ File name (customize if needed)
      link.download = `Caste_Certificate_${record.certificate_number}.pdf`

      document.body.appendChild(link)
      link.click()

      document.body.removeChild(link)
      window.URL.revokeObjectURL(url)
    } catch (error) {
      toast.error('Failed to download PDF')
      console.error(error)
    }
  }

  // --- OPEN MODAL ---
  const handleOpenModal = () => {
    setIsModalOpen(true)
  }

  // --- SEARCH ---
  const filteredData = data.filter((item) =>
    ((item.fee_name ?? '') + '')
      .toLowerCase()
      .includes(searchText.toLowerCase()),
  )

  const columns = [
    { title: 'Sr No', dataIndex: 'index' },
    { title: 'Certificate No.', dataIndex: 'certificate_number' },
    {
      title: 'Student Name',
      render: (_, record) =>
        `${record.applicantName} ${record.fatherName} ${record.surName}`,
    },
    { title: 'Year', dataIndex: 'year' },
    { title: 'WhatsApp No', dataIndex: 'whatsapp_number' },
    { title: 'City/Village', dataIndex: 'city' },
    { title: 'Pin Code', dataIndex: 'pin_code' },
    {
      title: 'Action',
      align: 'center',
      render: (_, record) => (
        <Space>
          <Button
            icon={<EyeOutlined />}
            size="small"
            onClick={() => {
              setViewGeneratedPdf(record.full_data)
            }}
          />
          <Button
            icon={<DownloadOutlined />}
            size="small"
            onClick={() => downloadPdf(record.full_data)}
          />
          <Button
            icon={<EditOutlined />}
            size="small"
            type="primary"
            onClick={() => handleEdit(record.full_data)}
          />
        </Space>
      ),
    },
  ]

  return (
    <div className="form-container mainContainer">
      <div className="row p-0 m-0 pb-5">
        <div className="col-12 col-md-2"></div>
        <div className="col-12 col-md-8">
          <div className="header-row">
            <h2 className="page-title">Caste Certificate</h2>
          </div>

          <div className="search-bar">
            <Input
              placeholder="Search Name..."
              prefix={<SearchOutlined />}
              value={searchText}
              onChange={(e) => setSearchText(e.target.value)}
              style={{ width: 250 }}
            />

            <Button
              className='addButton'
              icon={<PlusOutlined />}
              onClick={() => handleOpenModal()}
              style={{ marginLeft: 10 }}
            >
              Add Certificate
            </Button>
          </div>

          <Table
            columns={columns}
            dataSource={filteredData}
            pagination={{ pageSize: 10 }}
            bordered
            loading={loading}
           scroll={{ x: 'max-content' }}
            className='shadow border rounded'
          />
        </div>
        <div className="col-12 col-md-2"></div>
      </div>

      <Modal
        title={
          editingId ? 'Edit Caste Certificate' : 'Create Caste Certificate'
        }
        open={isModalOpen}
        onCancel={handleCancel}
        footer={null}
        size="large"
        width={900}
      >
        <div className="">
          <Row
            gutter={[16, 0]}
            className="p-2 rounded border"
            style={{ backgroundColor: '#f2f7fdff' }}
          >
            <Col xs={24} sm={8}>
              <Form.Item
                labelCol={{ span: 24 }}
                wrapperCol={{ span: 24 }}
                label="First Name"
                rules={[{ required: true }]}
              >
                <Input
                  placeholder="Enter first name"
                  size="large"
                  value={firstName}
                  onChange={(e) => setFirstName(e.target.value)}
                />
              </Form.Item>
            </Col>

            <Col xs={24} sm={8}>
              <Form.Item
                labelCol={{ span: 24 }}
                wrapperCol={{ span: 24 }}
                label="Middle Name"
                rules={[{ required: true }]}
              >
                <Input
                  placeholder="Enter middle name"
                  size="large"
                  value={middleName}
                  onChange={(e) => setMiddleName(e.target.value)}
                />
              </Form.Item>
            </Col>

            <Col xs={24} sm={8}>
              <Form.Item
                labelCol={{ span: 24 }}
                wrapperCol={{ span: 24 }}
                label="Last Name"
                rules={[{ required: true }]}
              >
                <Input
                  placeholder="Enter last name"
                  size="large"
                  value={lastName}
                  onChange={(e) => setLastName(e.target.value)}
                />
              </Form.Item>
            </Col>

            <Col xs={24} sm={8}>
              <Form.Item
                labelCol={{ span: 24 }}
                wrapperCol={{ span: 24 }}
                label="What's App No"
                validateStatus={mobileError ? 'error' : ''}
                help={mobileError}
                rules={[{ required: true }]}
              >
                <Input
                  placeholder="Enter 10 digit WhatsApp number"
                  size="large"
                  value={whatsappNo}
                  maxLength={10}
                  onChange={(e) => {
                    const value = e.target.value.replace(/\D/g, '').slice(0, 10)
                    setWhatsappNo(value)

                    if (value.length < 10) {
                      setMobileError('Mobile number must be 10 digits')
                    } else {
                      setMobileError('')
                    }
                  }}
                />
              </Form.Item>
            </Col>

            <Col xs={24} sm={8}>
              <Form.Item
                labelCol={{ span: 24 }}
                wrapperCol={{ span: 24 }}
                label="City/Village"
                rules={[{ required: true }]}
              >
                <Input
                  placeholder="Enter city or village"
                  size="large"
                  value={cityVillage}
                  onChange={(e) => {
                    const value = e.target.value.replace(/[^a-zA-Z\s]/g, '')
                    setCityVillage(value)
                  }}
                />
              </Form.Item>
            </Col>

            <Col xs={24} sm={8}>
              <Form.Item
                labelCol={{ span: 24 }}
                wrapperCol={{ span: 24 }}
                label="Pin Code"
                rules={[{ required: true }]}
              >
                <Input
                  placeholder="Enter 6 digit pin code"
                  size="large"
                  value={pincode}
                  maxLength={6}
                  onChange={(e) => {
                    const value = e.target.value.replace(/\D/g, '').slice(0, 6)
                    setPincode(value)
                  }}
                />
              </Form.Item>
            </Col>

            <Col xs={24} sm={24}>
              <Form.Item
                labelCol={{ span: 24 }}
                wrapperCol={{ span: 24 }}
                label="Resident of"
                rules={[{ required: true }]}
              >
                <Input.TextArea
                  rows={3}
                  placeholder="Full address"
                  value={address}
                  onChange={(e) => setAddress(e.target.value)}
                />
              </Form.Item>
            </Col>

            <Col xs={24} sm={8}>
              <Form.Item
                labelCol={{ span: 24 }}
                wrapperCol={{ span: 24 }}
                label="State"
                rules={[{ required: true, message: 'Please select a state' }]}
              >
                <Select
                  placeholder="Select State"
                  size="large"
                  value={stateId}
                  onChange={handleStateChange}
                  allowClear
                >
                  {states.map((s) => (
                    <Option key={s.id} value={s.id}>
                      {s.stateenname}
                    </Option>
                  ))}
                </Select>
              </Form.Item>
            </Col>

            <Col xs={24} sm={8}>
              <Form.Item
                labelCol={{ span: 24 }}
                wrapperCol={{ span: 24 }}
                label="District"
                rules={[
                  { required: true, message: 'Please select a district' },
                ]}
              >
                <Select
                  placeholder="Select District"
                  size="large"
                  value={districtId}
                  // onChange={handleDistrictChange}
                  onChange={(value) => handleDistrictChange(value, stateId)}
                  disabled={!stateId}
                  loading={loadingDistricts}
                  allowClear
                >
                  {districts.map((d) => (
                    <Option key={d.id} value={d.id}>
                      {d.districtenname}
                    </Option>
                  ))}
                </Select>
              </Form.Item>
            </Col>

            <Col xs={24} sm={8}>
              <Form.Item
                labelCol={{ span: 24 }}
                wrapperCol={{ span: 24 }}
                label="Taluka"
                rules={[{ required: true, message: 'Please select a taluka' }]}
              >
                <Select
                  placeholder="Select Taluka"
                  size="large"
                  disabled={!districtId}
                  loading={loadingTalukas}
                  allowClear
                  value={talukaId}
                  onChange={setTalukaId}
                >
                  {talukas.map((t) => (
                    <Option key={t.id} value={t.id}>
                      {t.talukaenname}
                    </Option>
                  ))}
                </Select>
              </Form.Item>
            </Col>

            <Col xs={24} sm={16}>
              <Form.Item
                labelCol={{ span: 24 }}
                wrapperCol={{ span: 24 }}
                label="Documents Collected"
                rules={[{ required: true, message: 'Please select documents' }]}
              >
                <Checkbox.Group
                  className="w-100"
                  value={documents}
                  onChange={(checkedValues) => setDocuments(checkedValues)}
                >
                  <Row className="border p-2 rounded bg-white">
                    <Col xs={24} sm={8}>
                      <Checkbox value="Aadhaar Card">Aadhaar Card</Checkbox>
                    </Col>
                    <Col xs={24} sm={6}>
                      <Checkbox value="School LC">School LC</Checkbox>
                    </Col>
                    <Col xs={24} sm={6}>
                      <Checkbox value="Orders">Orders</Checkbox>
                    </Col>
                  </Row>
                </Checkbox.Group>
              </Form.Item>
            </Col>

            <Col xs={24} sm={8}>
              <Form.Item
                labelCol={{ span: 24 }}
                wrapperCol={{ span: 24 }}
                label="Remark"
                rules={[{ required: true }]}
              >
                <Input
                  placeholder="Enter Remark"
                  size="large"
                  value={remark}
                  onChange={(e) => {
                    const value = e.target.value.replace(/[^a-zA-Z\s]/g, '')
                    setRemark(value)
                  }}
                />
              </Form.Item>
            </Col>
          </Row>

          <Row justify="center" style={{ marginTop: 20 }}>
            <Col>
              <Button
                type="default"
                
                size="large"
                style={{ marginRight: 10 }}
                onClick={handleCancel}
              >
                Cancel
              </Button>
            </Col>
            <Col>
              <Button
                className='addButton'
                size="large"
                onClick={editingId ? handleUpdate : handleSubmit}
                loading={loading}
                disabled={!!mobileError}
              >
                {editingId ? 'Update' : 'Submit'}
              </Button>
            </Col>
          </Row>
        </div>
      </Modal>
    </div>
  )
}

export default CreateCertificate
